angular.module('vastdesk').
  component('htmlAudioPlayer',  {
    bindings: {
      playerId: '@',
      src: '@'
    },
    template: '<audio id="{{$htmlAudioPlayerCtrl.playerId}}" ng-src="{{$htmlAudioPlayerCtrl.src}}" width="100%" controls></audio>',
    controllerAs: '$htmlAudioPlayerCtrl',
    controller: ['$rootScope', '$element', function($rootScope, $element) {

      var self = this;

      $rootScope.$on('audioChange', function(e, args) {
        if (args.playerId === self.playerId) {
          self.src = args.src;
        }
      });
    }]
});
